import { FrameworkTemplateViewModel } from "./FrameworkTemplateOverview.types.ts";
import { useParams } from "react-router";
import { useState } from "react";
import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery";

export function useFrameworkTemplateOverview() {
    const { id } = useParams<{ id: string }>();

    const [showEdit, setShowEdit] = useState(false);
    const [showToggleIsPublishedDialog, setShowToggleIsPublishedDialog] = useState<FrameworkTemplateViewModel | undefined>(undefined);

    const url = `/frameworks/templates/${id!}`;
    const { isLoading, data, refetch } = useDotLegalQuery<FrameworkTemplateViewModel>(url);

    return { isLoading, data, refetch, showEdit, setShowEdit, showToggleIsPublishedDialog, setShowToggleIsPublishedDialog };
}
